import { MenuOption as e } from "./MenuOption.es.js";
import { useEffect as t } from "react";
import { Check as n, Crop as r, Undo2 as i, ZoomIn as a, ZoomOut as o } from "lucide-react";
import { Fragment as s, jsx as c, jsxs as l } from "react/jsx-runtime";
//#region lib/components/CropDialog/Menu.tsx
var u = ({ onToggle: u, onZoom: d, onReset: f, active: p }) => (t(() => {
	let e = (e) => {
		if (!(!p || ![
			"Escape",
			"Enter",
			"+",
			"-"
		].includes(e.key))) switch (e.key) {
			case "Escape":
				f();
				break;
			case "Enter":
				u(!1);
				break;
			case "+":
				d("in");
				break;
			case "-": d("out");
		}
	};
	return document.addEventListener("keydown", e), () => {
		document.removeEventListener("keydown", e);
	};
}, [p, u]), /* @__PURE__ */ l("div", {
	contentEditable: !1,
	className: "absolute bottom-5 right-5 flex flex-col gap-1 items-center",
	children: [p && /* @__PURE__ */ l(s, { children: [
		/* @__PURE__ */ c(e, {
			onPress: () => d("in"),
			children: /* @__PURE__ */ c(a, {
				size: 20,
				strokeWidth: 1.75,
				className: "text-white ml-[2px] mt-[2px]"
			})
		}),
		/* @__PURE__ */ c(e, {
			onPress: () => d("out"),
			children: /* @__PURE__ */ c(o, {
				size: 20,
				strokeWidth: 1.75,
				className: "text-white ml-[2px] mt-[2px]"
			})
		}),
		/* @__PURE__ */ c(e, {
			onPress: () => f(),
			children: /* @__PURE__ */ c(i, {
				size: 20,
				strokeWidth: 1.75,
				className: "text-white ml-[1px]"
			})
		})
	] }), /* @__PURE__ */ c(e, {
		onPress: () => {
			u(!p);
		},
		children: p ? /* @__PURE__ */ c(n, {
			size: 20,
			strokeWidth: 2.75,
			className: "text-white "
		}) : /* @__PURE__ */ c(r, {
			size: 20,
			strokeWidth: 2.75,
			className: "text-white"
		})
	})]
}));
//#endregion
export { u as CropDialogMenu };
